/* PRISKEL REDESIGN — collection page: filters, sort, drawer, show more, SEO read-more */
(function () {
  var root = document.documentElement;
  function init(box) {
    if (!box || box.dataset.pkReady) return;
    box.dataset.pkReady = '1';
    var form = box.querySelector('[data-pk-form]');
    var side = box.querySelector('[data-pk-side]');
    var sid = box.getAttribute('data-section');
    var dirty = false;
    var mq = window.matchMedia('(max-width: 989px)');
    var sorts = [].slice.call(box.querySelectorAll('select[name="sort_by"]'));

    function tidy() {
      [].forEach.call(form.querySelectorAll('input[type="number"]'), function (i) { i.disabled = (i.value === ''); });
      sorts.forEach(function (s, i) { s.disabled = i > 0; });
    }
    function submit() {
      if (!form) return;
      tidy();
      if (form.requestSubmit) form.requestSubmit(); else form.submit();
    }
    if (form) form.addEventListener('submit', function () { tidy(); box.classList.add('is-loading'); });

    /* sort: keep both selects in step, then submit */
    sorts.forEach(function (s) {
      s.addEventListener('change', function () { sorts.forEach(function (o) { o.value = s.value; }); submit(); });
    });

    /* filters: instant on desktop, batched in the phone drawer */
    if (form) form.addEventListener('change', function (e) {
      var t = e.target;
      if (!t.matches('input[type="checkbox"]')) return;
      if (mq.matches && side.classList.contains('is-open')) { dirty = true; return; }
      submit();
    });

    /* phone drawer */
    var opener = box.querySelector('[data-pk-filter-open]');
    function openSide() { side.classList.add('is-open'); box.classList.add('is-side-open'); root.classList.add('pk-lock'); if (opener) opener.setAttribute('aria-expanded', 'true'); var f = side.querySelector('summary, input, a'); if (f) f.focus({ preventScroll: true }); }
    function closeSide() { if (dirty) { submit(); return; } side.classList.remove('is-open'); box.classList.remove('is-side-open'); root.classList.remove('pk-lock'); if (opener) { opener.setAttribute('aria-expanded', 'false'); opener.focus({ preventScroll: true }); } }
    if (opener) opener.addEventListener('click', openSide);
    [].forEach.call(box.querySelectorAll('[data-pk-filter-close]'), function (b) { b.addEventListener('click', closeSide); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && side.classList.contains('is-open')) closeSide(); });

    /* show more: append the next page in place */
    box.addEventListener('click', function (e) {
      var a = e.target.closest('[data-pk-more]');
      if (!a) return;
      e.preventDefault();
      if (a.dataset.busy) return;
      a.dataset.busy = '1';
      var label = a.textContent;
      a.textContent = 'Loading…';
      var href = a.getAttribute('href');
      var url = href + (href.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + encodeURIComponent(sid);
      fetch(url, { credentials: 'same-origin' }).then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var grid = box.querySelector('[data-pk-grid]');
        var ng = doc.querySelector('[data-pk-grid]');
        if (!grid || !ng) throw new Error('grid');
        [].forEach.call(ng.children, function (c) { if (!c.hasAttribute('data-pk-x')) grid.appendChild(document.importNode(c, true)); });
        var wrap = box.querySelector('[data-pk-more-wrap]');
        var nw = doc.querySelector('[data-pk-more-wrap]');
        if (wrap && nw) {
          var ns = nw.querySelector('[data-pk-shown]'), nb = nw.querySelector('[data-pk-bar]'), nm = nw.querySelector('[data-pk-more]');
          if (ns) wrap.querySelector('[data-pk-shown]').textContent = ns.textContent;
          if (nb) wrap.querySelector('[data-pk-bar]').style.width = nb.style.width;
          if (nm) { a.setAttribute('href', nm.getAttribute('href')); a.textContent = label; delete a.dataset.busy; }
          else a.remove();
          var pv = wrap.querySelector('.pk-cl__prev'); if (pv) pv.remove();
        }
        document.dispatchEvent(new CustomEvent('pk:collection:appended'));
      }).catch(function () { window.location.href = href; });
    });
  }

  /* SEO block: clamp + topic chips */
  function initSeo(s) {
    if (!s || s.dataset.pkReady) return;
    s.dataset.pkReady = '1';
    var body = s.querySelector('[data-pk-seo-body]');
    var btn = s.querySelector('[data-pk-seo-more]');
    var chips = s.querySelector('[data-pk-seo-chips]');
    if (!body || !btn) return;
    function open() { s.classList.add('is-open'); btn.setAttribute('aria-expanded', 'true'); btn.textContent = 'Read less'; }
    function close() { s.classList.remove('is-open'); btn.setAttribute('aria-expanded', 'false'); btn.textContent = 'Read more'; }
    var heads = [].slice.call(body.querySelectorAll('h3'));
    if (chips && heads.length) {
      heads.forEach(function (h, i) {
        if (!h.id) h.id = 'pk-seo-' + i;
        var c = document.createElement('a');
        c.className = 'pk-chip';
        c.href = '#' + h.id;
        c.textContent = h.textContent.trim();
        c.addEventListener('click', function (e) { e.preventDefault(); open(); h.scrollIntoView({ behavior: 'smooth', block: 'start' }); });
        chips.appendChild(c);
      });
    }
    if (body.scrollHeight <= body.clientHeight + 24) { s.classList.add('is-open'); btn.hidden = true; return; }
    btn.hidden = false;
    btn.addEventListener('click', function () { s.classList.contains('is-open') ? close() : open(); });
  }

  function run() {
    [].forEach.call(document.querySelectorAll('[data-pk-coll]'), init);
    [].forEach.call(document.querySelectorAll('[data-pk-seo]'), initSeo);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  document.addEventListener('shopify:section:load', run);
})();
